var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineaRainbowCarrear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 5,
    viewBox: "0 0 149 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.406 1.41797V0.917969H147.906H1H0.5V1.41797V3.42511V3.92511H1H147.906H148.406V3.42511V1.41797Z",
    fill: "url(#paint0_linear_217_2293)",
    stroke: "url(#paint1_linear_217_2293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_2293",
    x1: 0.999529,
    y1: 2.4213,
    x2: 147.906,
    y2: 2.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_217_2293",
    x1: 0.999529,
    y1: 2.4213,
    x2: 147.906,
    y2: 2.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaRainbowCarrear);
export default __webpack_public_path__ + "static/media/lineaRainbowCarrear.b4b6145436e6fd3df06f392376c9fb64.svg";
export { ForwardRef as ReactComponent };